import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App.tsx';
import { createBaseStore } from 'sama-shared';
import { createPersistConfig } from 'sama-shared/store/persistConfig';
import storefrontReducer from './features/storefront/slice/storefrontSlice';
import './index.css';

const storefrontPersistConfig = createPersistConfig('storefront', [
  'subdomain',
  'config',
  'selectedLocation',
  'orderType',
  'cart',
  'comboCart',
  'customer',
  'customerLocation',
  'customerId',
  'themeMode',
]);

const { store, persistor } = createBaseStore(
  { storefront: storefrontReducer },
  { storefront: storefrontPersistConfig }
);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </StrictMode>
);
